module.exports = function fullName(user) {
    if (! user) return ''
    // return first and last name
    const first_name = user.first_name || ''
    const last_name = user.last_name || ''
    const full_name = [
        first_name.trim(),
        last_name.trim(),
    ].join(' ')
    return full_name.trim()
}
